import { hasValue } from 'utils/values';

import { useAccessTokenStore } from '../store/useAccessTokenStore';

/**
 * Return true if user has access token.
 */
export function useAuthenticated() {
  return useAccessTokenStore((state) => hasValue(state.accessToken));
}
